<template>
    
    <b-container class="p-0">
        <b-row class="m-0 row-form" >
        
            <b-col lg="2" md="12">
                <b-row class="p-0 row-form-status">
                
                    <b-col cols="1">
                        <b-img :src="item.ImagePath" 
                               class="pr-25"/>
                    </b-col>
                    
                    <b-col class="pl-30">
                        <span class="form-status-text">
                            {{item.Status.rus}}
                        </span>
                    </b-col>

                    <b-col lg="1"  class="p-0">
                        <hr class="hr-v"/>
                    </b-col>

                </b-row>
            </b-col>      


            <b-col lg="4"  md="12" class="col-form-name">
                {{item.Name}}
            </b-col>

            <b-col class="col-form-address">
                {{item.Address}}
            </b-col>


            <!-- <b-col v-if="isOngoing && 
                         (item.Status.Id == 1 || item.Status.Id == 2) &&
                         (item.Status.Id == 1 && item.IsCanFinish ||
                          item.Place == 2 ||
                          item.Status.Id == 2)" 
                   cols="1" 
                   class="center"> -->

            <b-col v-if="isOngoing && item.ContainsTt" cols="1" class="center">

                <b-button variant="light"  
                          :id="`popover-button-sync-${index}`"
                          @click.stop>

                    <font-awesome-icon icon="ellipsis-v"                                           
                                       class="light-gray"/>
                </b-button>

                <b-popover  :target="`popover-button-sync-${index}`"
                            triggers="focus"
                            placement="bottom">

                    <b-container class="p-0-20">
                        
                        <!-- <b-row v-if="item.Status.Id == 1 && item.IsCanFinish" 
                               class="m-0 pointer popover-green-color" 
                               @click="completeFormDialog">
                            Завершить
                        </b-row> -->

                        <b-row v-if="item.ContainsTt"
                               class="m-0 pointer popover-red-color" 
                               @click="deleteFormDialog">
                            Удалить
                        </b-row>
                        
                        <!-- <b-row v-if="item.Status.Id == 2" 
                               class="m-0 pointer popover-default-color" 
                               @click="changeStatusDialog">
                            Изменить статус
                        </b-row> -->

                    </b-container>
                    
                </b-popover>

            </b-col>
        </b-row>    
    </b-container>

</template>

<script>
import '@/assets/styles/client/audit/formItem.css'

import dialogService from '@/services/dialog.service'
import apiService from '@/services/api.service'

    export default {
        props: {
            index: {
                type: Number,
                default: 0
            },
            item: {
                type: Object,
                default: null
            },
            isOngoing: {
                type: Boolean,
                default: false
            },
            load: {
                type: Object,
                default: () => {}
            }
        },
        data: function() {
            return {
                auditId: this.$route.query.id
            }
        },
        methods: {
            deleteFormDialog: function() {
                dialogService.showConfirm('Подтверждение удаления', 'Внимание, все ответы на вопросы будут безвозвратно удалены')
                    .then(ok => {                        
                        this.deleteForm();
                     })
                    .catch(cancel => {});
            },
            deleteForm: function() {
                this.load.Calculate(true);

                apiService.Client.Form.PostDelete(this.auditId, this.item.Id)
                    .then(response => {
                        this.$router.go(this.$router.currentRoute);
                    })
                    .catch(exception => {
                        this.load.Calculate(false);
                    });
            },


            // completeFormDialog: function() {
            //     dialogService.showConfirm( 'Подтверждение корректности данных', 'Нажимая «Продолжить», Вы подтверждаете корректность данных по анкете')
			// 		.then(ok => {})
			// 		.catch(cancel => { return });

            // },

            // changeStatusDialog: function() {
            //     dialogService.showConfirm( 'Перевод формы в статус "В работе"', 'Нажимая «Продолжить», Вы подтверждаете изменение статуса формы. Внимание! Функция доступна только администраторам.')
			// 		.then(ok => {
            //             this.changeStatus();
            //         })
			// 		.catch(cancel => { return });
            // },
            // changeStatus: function() {
            //     apiService.Client.Audit.GetChangeStatus(this.item.Id)
            //         .then(response => {
            //             this.$router.go(this.$router.currentRoute);
            //         })
            //         .catch(exception => {
            //             console.log(exception);
            //         });
            // }
            
        }

    }
</script>